let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("li9ds")).then(() => parcelRequire('kyM33'));